import { render, staticRenderFns } from "./SpaceCard.vue?vue&type=template&id=1d6b117c&scoped=true&lang=pug"
import script from "./SpaceCard.vue?vue&type=script&lang=js"
export * from "./SpaceCard.vue?vue&type=script&lang=js"
import style0 from "./SpaceCard.vue?vue&type=style&index=0&id=1d6b117c&prod&lang=css"
import style1 from "./SpaceCard.vue?vue&type=style&index=1&id=1d6b117c&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6b117c",
  null
  
)

export default component.exports